import { render, staticRenderFns } from "./ViewLog.vue?vue&type=template&id=070b50d3&"
import script from "./ViewLog.vue?vue&type=script&lang=ts&"
export * from "./ViewLog.vue?vue&type=script&lang=ts&"
import style0 from "./ViewLog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports